import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface FileUploadResponse {
  url: string;
  path?: string;
  imageUrl?: string;
  fileUrl?: string;
  fileName?: string;
}

export const filesApi = {
  upload: (file: File, directory?: string, name?: string) => {
    const form = new FormData();
    form.append('file', file);
    if (directory) {
      form.append('directory', directory);
      form.append('folder', directory);
    }
    if (name) form.append('name', name);
    return unwrap(
      api.post<ApiResponse<FileUploadResponse>>('/v1/files/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    );
  },

  uploadDocument: (file: File, name?: string) => {
    const form = new FormData();
    form.append('file', file);
    form.append('directory', 'documents');
    if (name) form.append('name', name);
    return unwrap(
      api.post<ApiResponse<FileUploadResponse>>('/v1/files/upload/document', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    );
  },
};
